interface StatusConfig {
  display: string
  backgroundColor: string
  statusColor: string
}

const installationStatuses: { [key: string]: StatusConfig } = {
  completed: {
    display: 'Completed',
    backgroundColor: '#D9FBE7',
    statusColor: '#79E4A5',
  },
  on_site: {
    display: 'On Site',
    backgroundColor: '#EBF0FF',
    statusColor: '#B5C8FF',
  },
  started: {
    display: 'Started',
    backgroundColor: '#F5EAFF',
    statusColor: '#D7ABFF',
  },
  en_route: {
    display: 'En Route',
    backgroundColor: '#E5F6FF',
    statusColor: '#A4DCFF',
  },
  cancelled_onsite: {
    display: 'Cancelled Onsite',
    backgroundColor: '#EEEEEE',
    statusColor: '#CECECE',
  },
  cancelled: {
    display: 'Cancelled',
    backgroundColor: '#EEEEEE',
    statusColor: '#CECECE',
  },
  almost_late: {
    display: 'Almost Late',
    backgroundColor: '#F9F3CD',
    statusColor: '#EFDA4D',
  },
  late: {
    display: 'Late',
    backgroundColor: '#FFE2E2',
    statusColor: '#FD9191',
  },
  technician_not_available: {
    display: 'Tech Not Available',
    backgroundColor: '#FFE8D1',
    statusColor: '#FFB76E',
  },
  scheduled: {
    display: 'Scheduled',
    backgroundColor: '#FFFFFF',
    statusColor: '#141414',
  },
  pending_rescheduling: {
    display: 'Pending Rescheduling',
    backgroundColor: '#FFFFFF',
    statusColor: '#141414',
  },
  fixed: {
    display: 'Fixed',
    backgroundColor: 'none',
    statusColor: '#EEEEEE',
  },
}

const deliveryStatuses: { [key: string]: StatusConfig } = {
  completed: {
    display: 'Delivered',
    backgroundColor: '#D9FBE7',
    statusColor: '#79E4A5',
  },
  on_site: {
    display: 'Arrived',
    backgroundColor: '#EBF0FF',
    statusColor: '#B5C8FF',
  },
  started: {
    display: 'Arrived',
    backgroundColor: '#F5EAFF',
    statusColor: '#D7ABFF',
  },
  en_route: {
    display: 'Out for Delivery',
    backgroundColor: '#E5F6FF',
    statusColor: '#A4DCFF',
  },
  cancelled_onsite: {
    display: 'Delivery Cancelled',
    backgroundColor: '#EEEEEE',
    statusColor: '#CECECE',
  },
  cancelled: {
    display: 'Delivery Cancelled',
    backgroundColor: '#EEEEEE',
    statusColor: '#CECECE',
  },
  almost_late: {
    display: 'Out for Delivery',
    backgroundColor: '#F9F3CD',
    statusColor: '#EFDA4D',
  },
  late: {
    display: 'Out for Delivery',
    backgroundColor: '#FFE2E2',
    statusColor: '#FD9191',
  },
  technician_not_available: {
    display: 'Driver Not Available',
    backgroundColor: '#FFE8D1',
    statusColor: '#FFB76E',
  },
  scheduled: {
    display: 'Delivery',
    backgroundColor: '#FFFFFF',
    statusColor: '#141414',
  },
  pending_rescheduling: {
    display: 'Delivery Needs Rescheduling',
    backgroundColor: '#FFFFFF',
    statusColor: '#141414',
  },
  fixed: {
    display: 'Fixed',
    backgroundColor: 'none',
    statusColor: '#EEEEEE',
  },
}

export { installationStatuses, deliveryStatuses }
